import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@material-ui/core/Button';
import { FOOTER_LABEL_PREFIX } from './BuyFooter';


export const ExpiredFooterBody = ({ onRefresh }) => {
  const intl = useIntl();
  return (
    <>
      <div className={'priceAndTime'}>
        <FormattedMessage
          className={'label'}
          id={`${FOOTER_LABEL_PREFIX}.refreshText`}
        />
      </div>
      <Button
        className={'actionButton'}
        variant="contained"
        color="primary"
        onClick={onRefresh}>
        {intl.formatMessage({
          id: `${FOOTER_LABEL_PREFIX}.refreshButton`,
        })}
      </Button>
    </>);
};

ExpiredFooterBody.propTypes = {
  onRefresh: PropTypes.func,
};
